export const hotelData = {
  name: "서울 N 호텔 동대문",
  rating: 8.2,
  reviewCount: 12247,
  location: "서울특별시 종로구 종로66가길 21(종로), 동대문, 서울, 대한민국, 03115",
  description: "활기찬 동대문 근처에 위치한 서울 N 호텔 동대문은 전세계 여행자들을 위해 존재합니다. 두 명의 여행자에게 완벽하며, 서울의 인기 명소인 동대문 디자인 플라자에 쉽게 접근할 수 있습니다. 서울 N 호텔 동대문에서 24시간 프런트 서비스와 프라이빗 체크인/체크아웃을 통해 완벽한 서비스를 누리세요.  맛있는 아침 식사로 하루를 시작하세요. 전 객실  아름다운 전망과 무료 무선 인터넷이 제공되는 에어컨이 있는 객실에서 편안히 쉬세요. 서울의 활기찬 문화, 트렌디한 쇼핑 지구 및 역사적 명소를 탐험하면서 멋진 도시 전망을 감상하세요. 비즈니스든 레저든 신설동 지하철역 근처의 최적의 위치는 서울에서의 체류에 완벽한 기반을 제공합니다.",
  checkIn: "15:00",
  checkOut: "11:00",
  amenities: [
    { icon: "ri-wifi-line", name: "무료 Wi-Fi" },
    { icon: "ri-restaurant-line", name: "레스토랑" },
    { icon: "ri-washing-machine-line", name: "코인세탁기" },
    { icon: "ri-24-hours-line", name: "24시간 프런트" },
    { icon: "ri-air-conditioner-line", name: "에어컨" },
    { icon: "ri-tv-line", name: "TV" },
    { icon: "ri-safe-line", name: "금고" },
    { icon: "", name: "여행안내소" }
  ],
  images: [
    "https://static.readdy.ai/image/4543dd9147b9558167d2c4d076d8e122/4e40f429c59d83d72e3e77e09380625d.jpeg",
    "https://static.readdy.ai/image/4543dd9147b9558167d2c4d076d8e122/5214e3a448576fc435e8ebc6135bce92.png",
    "https://static.readdy.ai/image/4543dd9147b9558167d2c4d076d8e122/c9907457f666afe20cf650c7a8740fe7.png",
    "https://static.readdy.ai/image/4543dd9147b9558167d2c4d076d8e122/84efc7c89f64bb12a6118c9b42560096.png",
    "https://static.readdy.ai/image/4543dd9147b9558167d2c4d076d8e122/86e759dc9d1c3e280070c182c98e27ee.png"
  ],
  nearbyAttractions: [
    { name: "동대문 디자인 플라자", distance: "0.5km", time: "도보 6분" },
    { name: "명동 쇼핑가", distance: "1.2km", time: "도보 15분" },
    { name: "남산타워", distance: "2.8km", time: "차량 10분" },
    { name: "경복궁", distance: "3.5km", time: "차량 15분" }
  ],
  policies: [
    "체크인: 15:00부터",
    "체크아웃: 11:00까지",
    "반려동물 동반 불가",
    "흡연 금지",
    "취소 정책: 체크인 3일 전까지 무료 취소"
  ]
};

export const roomTypes = [
  {
    id: 1,
    name: "스탠다드 더블룸",
    size: "13㎡",
    bedType: "더블 베드 1개",
    maxGuests: 2,
    price: 89000,
    originalPrice: 125000,
    discount: 29,
    image: "https://static.readdy.ai/image/4543dd9147b9558167d2c4d076d8e122/e9b0faa27c30ce4f6b5a65284f349409.png",
    amenities: ["무료 Wi-Fi", "에어컨", "TV", "냉장고", "헤어드라이어"],
    available: 3
  },
  {
    id: 2,
    name: "디럭스 트윈룸",
    size: "13㎡",
    bedType: "싱글 베드 2개",
    maxGuests: 2,
    price: 85000,
    originalPrice: 145000,
    discount: 28,
    image: "https://static.readdy.ai/image/4543dd9147b9558167d2c4d076d8e122/ca9fe0a460df0acc54755c15502cac70.jpeg",
    amenities: ["무료 Wi-Fi", "에어컨", "TV", "냉장고", "헤어드라이어", "커피머신"],
    available: 5
  },
  {
    id: 3,
    name: "패밀리 트리플룸",
    size: "16㎡",
    bedType: "벙크베드 1개  더블베드 1개",
    maxGuests: 3,
    price: 135000,
    originalPrice: 185000,
    discount: 27,
    image: "https://static.readdy.ai/image/4543dd9147b9558167d2c4d076d8e122/254daeb6fb2c2b0b5e01acf7a9594075.png",
    amenities: ["무료 Wi-Fi", "에어컨", "TV", "냉장고", "헤어드라이어", "커피머신"],
    available: 2
  },
  {
    id: 4,
    name: "디럭스 트리플룸",
    size: "16㎡",
    bedType: "벙크베드 1개 싱글베드 2개",
    maxGuests: 3,
    price: 145000,
    originalPrice: 265000,
    discount: 29,
    image: "https://static.readdy.ai/image/4543dd9147b9558167d2c4d076d8e122/c0de9937cece626b0d8e0ac9d66d555e.png",
    amenities: ["무료 Wi-Fi", "에어컨", "TV", "냉장고", "헤어드라이어", "커피머신"],
    available: 1
  }
];

export const reviews = [
  {
    id: 1,
    userName: "김민수",
    rating: 9.0,
    date: "2025년 1월",
    country: "대한민국",
    comment: "위치가 정말 좋았어요. 동대문까지 걸어갈 수 있고, 주변에 맛집도 많았습니다. 객실도 깨끗하고 직원분들도 친절했어요.",
    helpful: 24
  },
  {
    id: 2,
    userName: "이지은",
    rating: 8.5,
    date: "2025년 1월",
    country: "대한민국",
    comment: "가격 대비 만족스러웠습니다. 조식이 맛있었고, 방도 넓고 편안했어요. 다음에 또 이용하고 싶습니다.",
    helpful: 18
  },
  {
    id: 3,
    userName: "박준호",
    rating: 7.8,
    date: "2024년 12월",
    country: "대한민국",
    comment: "전반적으로 괜찮았어요. 다만 주차장이 좀 협소했습니다. 그래도 위치와 서비스는 만족스러웠어요.",
    helpful: 12
  },
  {
    id: 4,
    userName: "최수진",
    rating: 9.2,
    date: "2024년 12월",
    country: "대한민국",
    comment: "정말 좋은 호텔이었습니다! 직원분들이 매우 친절하시고, 객실 청소 상태도 완벽했어요. 강력 추천합니다.",
    helpful: 31
  },
  {
    id: 5,
    userName: "정현우",
    rating: 8.0,
    date: "2024년 12월",
    country: "대한민국",
    comment: "비즈니스 출장으로 이용했는데 만족스러웠습니다. Wi-Fi도 빠르고 업무하기 좋은 환경이었어요.",
    helpful: 9
  }
];